import type { DraggableData } from "@/dnd/ids";
import { ConnectorsRailConnectorRow } from "@/layouts/WorkspaceLayout/components/WorkspaceLeftRail/connectors/ConnectorsRailConnectorRow";
import type { IntegrationConnection } from "@cohesive/api-client";
import { useDraggable } from "@dnd-kit/core";
import { useMemo } from "react";

/** Draggable connector row — must render inside `TransferDndProvider`. */
export function ConnectorsRailDraggableConnectorRow({
  connection,
  dragNamespace,
}: {
  connection: IntegrationConnection;
  dragNamespace: string;
}) {
  const draggableData: DraggableData = useMemo(
    () => ({
      kind: "integration-connection",
      connectionIds: [connection.id],
      primaryName: connection.integration_name,
      platform: connection.integration_platform,
      imageURL: connection.integration_image_url,
    }),
    [
      connection.id,
      connection.integration_name,
      connection.integration_platform,
      connection.integration_image_url,
    ],
  );

  const draggable = useDraggable({
    id: `connectors-rail:${dragNamespace}:${connection.id}`,
    data: draggableData,
  });

  return (
    <ConnectorsRailConnectorRow
      connection={connection}
      dragRef={draggable.setNodeRef}
      dragProps={{
        ...draggable.attributes,
        ...draggable.listeners,
      }}
      isDragging={draggable.isDragging}
    />
  );
}
